import { createPortal } from 'react-dom'
import { useUpdateCheck } from 'react-update-notification'

export const CriticalUpdateNotification = () => {
  const { status, reloadPage } = useUpdateCheck({
    type: 'interval',
    interval: 10000,
    ignoreServerCache: true,
  })

  if (status !== 'available') {
    return null
  }

  return createPortal(
    <div className="bg-danger-default pointer-events-auto fixed bottom-4 right-4 z-[10000000] flex max-w-md items-center gap-4 rounded-2xl  px-4 py-3 text-white shadow-lg">
      <div className="flex-1">
        <p className="w-auto text-sm font-semibold ">
          There is an update available! Please click the &quot;Reload&quot;
          button to update.
        </p>
      </div>
      <button
        onClick={reloadPage}
        className="rounded-lg bg-gray-800 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-700"
      >
        Reload
      </button>
    </div>,
    document.body,
  )
}
